import { Form } from '@anytag/shared-atoms';
import { FormAction } from '@anytag/shared-types';
import { Template } from './Template';
import { defaultInfluencerFormValues } from './utils';
import { InfluencerFormSchema, InfluencerFormValues } from './schema-types';

export type InfluencerFormProps = FormAction<InfluencerFormValues>;

export const InfluencerForm = ({ onSubmit, defaultValues = defaultInfluencerFormValues }: InfluencerFormProps) => (
  <Form.Provider<InfluencerFormValues>
    onSubmit={onSubmit}
    className="bg-transparent"
    zodSchema={InfluencerFormSchema}
    values={defaultValues as InfluencerFormValues}
  >
    <Template />
  </Form.Provider>
);

export * from './schema-types';
export { defaultInfluencerFormValues, getInfluencerFormValues, getCreateUpdateInfluencerInput } from './utils';
